import type { CalendarActionData } from '@healthhub/message-channel';
import { DDDD_DD_MMMM_YYYY_HH_MM_A_FORMAT, MessageChannelBridge } from '@healthhub/react-ui';

import { showCalendarDownloadModal } from '@shared/components';
import { APPOINTMENT_PATH } from '@shared/constants/paths';
import { MESSAGE_ACTION } from '@shared/utils/bridge';
import { formattedDateDisplay } from '@shared/utils/date/dateUtil';

import type { ServiceTypeDetails, ServiceTypeMap } from '@features/Appointment/types/appointment.types';

interface AddCalendarAppointmentParams extends Omit<CalendarActionData, 'path'> {
  isNUP?: boolean;
}

export const addCalendarAppointment = ({
  endDate,
  location,
  startDate,
  title,
  isNUP = false,
  layoutView,
}: AddCalendarAppointmentParams) => {
  const dateString = formattedDateDisplay(startDate, DDDD_DD_MMMM_YYYY_HH_MM_A_FORMAT);
  let description = `You have an appointment: ${title} at ${location} on ${dateString}`;
  if (title?.startsWith('Appointment at') && isNUP) {
    description = `You have an appointment: ${title} on ${dateString}`;
  }

  MessageChannelBridge.sendMessageToNativeBridge(
    MESSAGE_ACTION.calendar({
      description,
      location,
      path: APPOINTMENT_PATH,
      startDate,
      title,
      endDate,
      layoutView,
    })
  );

  showCalendarDownloadModal();
};

export const checkIsValidVcFormRedirection = (
  validServiceTypeMapping: null | ServiceTypeMap,
  requestFormType: string
) =>
  !!Object.values(validServiceTypeMapping || {}).some(
    (value: ServiceTypeDetails) => value?.RequestFormType === requestFormType
  );
